import React from "react";
import { defaultState } from "tsi-common-react/src/apps/reviews/defaults";
import { updateFilterOptionValue } from "tsi-common-react/src/apps/reviews/reducers";
import { IReviewQueryFacets } from "tsi-common-react/src/models/reviews";
import {
    useAppDispatch,
    useAppSelector,
} from "tsi-common-react/src/store/reducers";
import { parseFacetValues } from "tsi-common-react/src/utils/reviews";

import { UnstyledSelect } from "../../../components/UnstyledSelect";
import { FilterOptions } from "../FilterOptions";

const FACET_TYPE: IReviewQueryFacets = "product_id";

export const ProductFilter = () => {
    const dispatch = useAppDispatch();

    const productFacet = useAppSelector((state) => {
        const reviewsState = state.reviews || defaultState;
        return (
            reviewsState.data.facets.find(
                (facet) => facet.type === FACET_TYPE,
            ) || null
        );
    });

    const value = useAppSelector((state) => {
        const reviewsState = state.reviews || defaultState;
        const values = parseFacetValues(
            reviewsState.ui.facetValues[FACET_TYPE] || "",
        );
        return values[0] || "";
    });

    const options = productFacet ? productFacet.options : [];
    return (
        <div className="reviews-region-stars">
            <UnstyledSelect
                noBorder
                className="select select--large-down-arrow review-select"
                value={value}
                onChange={(e) => {
                    const optID = parseInt(e.currentTarget.value, 10) || 0;
                    const isSelected = !!optID;
                    dispatch(
                        updateFilterOptionValue({
                            facetType: FACET_TYPE,
                            optionID: optID,
                            isSelected: isSelected,
                            isExclusive: true,
                        }),
                    );
                }}
            >
                {/* TODO(i18n): Wrap in t tagged template: {t`Product`} */}
                <option value="" disabled={true}>
                    Product
                </option>
                {/* TODO(i18n): Wrap in t tagged template: {t`Any`} */}
                <option value="any">Any</option>
                <FilterOptions options={options} />
            </UnstyledSelect>
        </div>
    );
};
